import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentSpecialtiesUpdateDto, AgentSpecialty } from '@workspace/data-types';

export interface SpecialtyItem {
  key: AgentSpecialty | string;
  label: string;
  icon: string;
}

export const AVAILABLE_SPECIALTIES: SpecialtyItem[] = [
  { key: AgentSpecialty.APARTMENT, label: 'Appartements', icon: 'apartment' },
  { key: AgentSpecialty.HOUSE, label: 'Maisons & Villas', icon: 'home' },
  { key: AgentSpecialty.PRESTIGE, label: 'Prestige & Luxe', icon: 'diamond' },
  { key: AgentSpecialty.BUILDING, label: 'Immeubles de rapport', icon: 'domain' },
  { key: AgentSpecialty.LAND, label: 'Terrains', icon: 'landscape' },
  { key: AgentSpecialty.COMMERCIAL, label: 'Commerces & Pro', icon: 'storefront' },
];

@Component({
  selector: 'etxe-agent-specialties-form',
  imports: [MatIconModule],
  templateUrl: './agent-specialties-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSpecialtiesFormComponent {
  readonly specialties = input<(AgentSpecialty | string)[]>([]);
  readonly specialtiesChange = output<(AgentSpecialty | string)[]>();
  readonly validityChanged = output<boolean>();
  readonly dtoChanged = output<{ dto: AgentSpecialtiesUpdateDto; changed: boolean }>();

  readonly availableSpecialties = AVAILABLE_SPECIALTIES;
  readonly internalSpecialties = signal<(AgentSpecialty | string)[]>([]);

  constructor() {
    effect(() => {
      const init = this.specialties();
      this.internalSpecialties.set([...init]);
      this.validityChanged.emit(true);
      this.dtoChanged.emit({ dto: { specialties: init }, changed: false });
    });
  }

  isSpecialtySelected(key: AgentSpecialty | string): boolean {
    return this.internalSpecialties().includes(key);
  }

  toggleSpecialty(key: AgentSpecialty | string): void {
    const current = this.internalSpecialties();
    let updated: (AgentSpecialty | string)[];
    if (current.includes(key)) {
      updated = current.filter((s) => s !== key);
    } else {
      updated = [...current, key];
    }
    this.internalSpecialties.set(updated);
    this.specialtiesChange.emit(updated);
    this.validityChanged.emit(true);

    const initial = this.specialties();
    const isDifferent = updated.length !== initial.length || updated.some((item) => !initial.includes(item));
    this.dtoChanged.emit({ dto: { specialties: updated }, changed: isDifferent });
  }
}
